module.exports = __webpack_public_path__ + "static/media/responsibleDaughter2007.f172d751.jpg";